// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64(),
  owner: __t.identity(),
  worldId: __t.u64().name("world_id"),
  npcId: __t.u64().name("npc_id"),
  kind: __t.u8(),
  text: __t.string(),
  about: __t.string(),
  at: __t.timestamp(),
});
